export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/components/app-sidebar-footer/index.ts